<template>
    <div class="logistics_step_container">
        <div class="logistics_base_info">
            <div class="logistics_info">
                <span>{{ logisticsInfo.logisticsName }}</span>
                <span class="logistics_number">{{
                    logisticsInfo.logisticsOrderNo
                }}</span>
            </div>
        </div>
        <ul class="logistics_list">
            <li
                class="logistics_item"
                v-for="(item, index) in logisticsList"
                :key="index"
            >
                <div class="logistics_text">
                    <p>{{ item.logisticsInformation }}</p>
                </div>
                <div class="logistics_time">
                    <span>{{ item.logisticsTime }}</span>
                </div>
            </li>
        </ul>
        <div
            v-if="
                logisticsInfo &&
                    logisticsInfo.logisticsTrajectoryList &&
                    logisticsInfo.logisticsTrajectoryList.length >
                        baseLimitedNumber
            "
            class="spread"
            @click="isMore = !isMore"
        >
            <span>{{ isMore ? "收起" : "展开" }}</span>
            <i :class="{ 'arrow-top-icon': isMore }"></i>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        logisticsInfo: {
            type: [Object],
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            baseLimitedNumber: 3,
            isMore: false,
        };
    },
    computed: {
        logisticsList() {
            let isMore = this.isMore;
            let tempList = [];
            let logisticsInfoList =
                this.logisticsInfo.logisticsTrajectoryList || [];
            if (
                !Array.isArray(logisticsInfoList) ||
                logisticsInfoList.length == 0
            ) {
                return tempList;
            }
            if (!isMore) {
                tempList = [...logisticsInfoList].slice(0, 3);
            } else {
                tempList = [...logisticsInfoList];
            }
            return tempList;
        },
    },
};
</script>

<style lang="less" scoped>
.logistics_step_container {
    margin: 0 0 15px 0;
    width: 750px;
    background-color: #fff;
    > .logistics_base_info {
        height: 108px;
        padding: 0px 30px;
        background-image: url("../../../../public/images/user/order/logistics_icon.png");
        background-repeat: no-repeat;
        background-size: 48px;
        background-position: 30px center;
        font-size: 24px;
        line-height: 108px;
        > .logistics_info {
            padding-left: 60px;
            border-bottom: 1px solid #f2f2f2;
            > .logistics_number {
                padding-left: 10px;
            }
        }
    }
    > .logistics_list {
        overflow: hidden;
        width: 750px;
        .logistics_item {
            display: block;
            margin: 0 0 0 30px;
            padding: 30px 0;
            width: 720px;
            border-bottom: 1px solid #f2f2f2;
            > .logistics_text {
                padding: 0 30px 0 0;
                font-size: 24px;
                text-align: justify;
                line-height: 1.5;
            }
            > .logistics_time {
                margin: 10px 0 0 0;
                font-size: 24px;
                text-align: #999;
            }
        }
    }

    > .spread {
        margin: 0 30px;
        height: 60px;
        font-size: 24px;
        line-height: 60px;
        color: #999;
        text-align: center;

        span {
            vertical-align: middle;
        }

        i {
            display: inline-block;
            width: 40px;
            height: 40px;
            background: url(../../../../public/images/common/arrow-bottom-icon.png)
                center no-repeat;
            background-size: 100%;
            vertical-align: middle;

            &.arrow-top-icon {
                background-image: url(../../../../public/images/common/arrow-top-icon.png);
            }
        }
    }
}
</style>
